import { translationLivechat_sv_part1 } from "./translationLivechat.sv.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationLivechat_sv_part2 } from "./translationLivechat.sv.part2";
import { translationLivechat_sv_part3 } from "./translationLivechat.sv.part3";
import { translationLivechat_sv_availability } from "./translationLivechat.sv.availability";
import { translationLivechat_sv_autoClose } from "./translationLivechat.sv.autoClose";
import { translationLivechat_sv_case } from "./translationLivechat.sv.case";
import { translationLivechat_sv_edit } from "./translationLivechat.sv.edit";
import { translationLivechat_sv_header } from "./translationLivechat.sv.header";
import { translationLivechat_sv_schedules } from "./translationLivechat.sv.schedules";

export const translationLivechat_sv = defineTranslationTree({
  ...translationLivechat_sv_availability,
  ...translationLivechat_sv_autoClose,
  ...translationLivechat_sv_case,
  ...translationLivechat_sv_edit,
  ...translationLivechat_sv_header,
  ...translationLivechat_sv_schedules,
  ...translationLivechat_sv_part1,
  ...translationLivechat_sv_part2,
  ...translationLivechat_sv_part3,
});
